import * as Sentry from '@sentry/browser'

/**
 * Load Sentry
 * @param {string} dsn - Sentry DSN
 */
export const loadSentry = (dsn) => {
  Sentry.init({
    dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    beforeSend: (event) => {
      if (
        // @ts-ignore
        typeof window.disableSentry === 'function' &&
        // @ts-ignore
        window.disableSentry() === true
      ) {
        return null
      }
      return event
    },
    // Tracing
    tracesSampleRate: 0.5, //  Capture 50% of the transactions
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/trbotrkr\.com\//,
      /^https:\/\/(?:.+\.)?turbodevhub\.com\//,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  })

  // grab the user trace to pass to HotJar
  const sentryUserTrace = Sentry.withScope((scope) => {
    const userTraceId = scope.getScopeData().propagationContext.traceId
    return userTraceId || null
  })

  // @ts-ignore
  window.sentryUserTraceId = sentryUserTrace
}
